import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { REWARDS_TIERS, DONATE_AMOUNTS } from "../mock/mock";
import { MapPin, Phone, Trophy, Heart, Check } from "lucide-react";
import { toast } from "sonner";

const SITTERS = [
  { name: "Aisha Khan", suburb: "Fitzroy", rate: "$45/day", tag: "In-home · dogs & cats" },
  { name: "Tom Reilly", suburb: "St Kilda", rate: "$60/day", tag: "At theirs · fenced yard" },
  { name: "Mei Lin", suburb: "Brunswick", rate: "$35/day", tag: "In-home · cats only" },
  { name: "Jack Doyle", suburb: "Richmond", rate: "$85/day", tag: "At theirs · 24/7 care" },
];

export default function FeatureModals({ type, onClose }) {
  const [amount, setAmount] = useState(15);
  const open = !!type;

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-[400px] rounded-3xl">
        {type === "sitters" && (
          <>
            <DialogHeader>
              <DialogTitle className="font-head text-xl font-extrabold">🏡 Trusted dog sitters</DialogTitle>
            </DialogHeader>
            <p className="text-sm text-slate-500 font-semibold -mt-1">In-home or at theirs · all vetted</p>
            <div className="space-y-2 mt-2 max-h-80 overflow-y-auto">
              {SITTERS.map((s) => (
                <div key={s.name} className="flex items-center justify-between bg-slate-50 rounded-2xl p-3">
                  <div>
                    <div className="font-extrabold text-slate-900">{s.name}</div>
                    <div className="text-xs text-slate-500 font-semibold flex items-center gap-1">
                      <MapPin className="w-3 h-3" /> {s.suburb} · {s.tag}
                    </div>
                  </div>
                  <div className="text-right">
                    <div className="font-extrabold text-teal-600">{s.rate}</div>
                    <Button
                      size="sm"
                      onClick={() => toast.success(`Booking request sent to ${s.name}!`)}
                      className="h-7 mt-1 rounded-full bg-teal-500 hover:bg-teal-600 text-white text-xs font-bold px-3"
                    >
                      Book
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {type === "rewards" && (
          <>
            <DialogHeader>
              <DialogTitle className="font-head text-xl font-extrabold flex items-center gap-2">
                <Trophy className="w-5 h-5 text-amber-500" /> Pawws Rewards
              </DialogTitle>
            </DialogHeader>
            <div className="bg-amber-50 rounded-2xl p-4 text-center">
              <div className="text-4xl font-extrabold text-amber-500 font-head">125</div>
              <div className="text-xs font-bold text-amber-600">your points</div>
            </div>
            <div className="text-xs font-bold text-slate-500 mt-1">
              +25 pts per stray reported · +50 per sighting
            </div>
            <div className="space-y-2 mt-2">
              {REWARDS_TIERS.map((t) => {
                const unlocked = 125 >= t.pts;
                return (
                  <div key={t.pts} className="flex items-center justify-between bg-slate-50 rounded-2xl p-3">
                    <div>
                      <div className="font-extrabold text-slate-900">{t.title}</div>
                      <div className="text-xs text-slate-500 font-semibold">{t.perk}</div>
                    </div>
                    <div className={`text-xs font-extrabold px-2.5 py-1 rounded-full flex items-center gap-1 ${unlocked ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-500"}`}>
                      {unlocked ? <Check className="w-3 h-3" /> : null} {t.pts} pts
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}

        {type === "donate" && (
          <>
            <DialogHeader>
              <DialogTitle className="font-head text-xl font-extrabold flex items-center gap-2">
                <Heart className="w-5 h-5 text-blue-500" fill="currentColor" /> Support the cause
              </DialogTitle>
            </DialogHeader>
            <p className="text-sm text-slate-500 font-semibold -mt-1">
              $5 covers a vet visit co-pay. $50 saves a life.
            </p>
            <div className="grid grid-cols-4 gap-2 mt-2">
              {DONATE_AMOUNTS.map((a) => (
                <button
                  key={a}
                  onClick={() => setAmount(a)}
                  className={`py-3 rounded-2xl font-extrabold border-2 transition-colors ${amount === a ? "border-blue-500 bg-blue-50 text-blue-600" : "border-slate-200 text-slate-600"}`}
                >
                  ${a}
                </button>
              ))}
            </div>
            <Button
              onClick={() => { toast.success(`Thank you! $${amount} donation received \uD83D\uDC99`); onClose(); }}
              className="w-full h-12 rounded-2xl bg-blue-500 hover:bg-blue-600 text-white font-extrabold mt-2"
            >
              Donate ${amount}
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
